<div class="backdrop" (click)="onCloseMenu()"></div>
<app-main-navigation-trigger class="menu-trigger" />
<div class="logo-wrapper">
  <app-logo />
</div>
<nav class="nav-wrapper">
  <p class="nav-label">{{ "navigation.primaryLabel" | translate }}</p>
  @for (item of visiblePrimaryNav; track item.labelKey) {
    @if (item.sub) {
      <div
        class="nav-item-group"
        routerLinkActive
        #subGroupRla="routerLinkActive"
      >
        @if (getMainLink(item); as mainLink) {
          <a
            class="nav-item"
            [routerLink]="mainLink"
            (click)="onCloseMenu()"
            [class.active]="subGroupRla.isActive"
          >
            @if (item.icon) {
              <app-icon [name]="item.icon"></app-icon>
            }
            {{ item.labelKey | translate }}
          </a>
        }
        @for (subItem of getSubItems(item); track subItem.labelKey) {
          <a
            class="nav-item sub-item"
            [routerLink]="subItem.link"
            (click)="onCloseMenu()"
            routerLinkActive="active"
          >
            @if (subItem.icon) {
              <app-icon [name]="subItem.icon"></app-icon>
            }
            {{ subItem.labelKey | translate }}
          </a>
        }
      </div>
    } @else if (item.link) {
      <a
        class="nav-item"
        [routerLink]="item.link"
        (click)="onCloseMenu()"
        routerLinkActive="active"
      >
        @if (item.icon) {
          <app-icon [name]="item.icon"></app-icon>
        }
        {{ item.labelKey | translate }}
      </a>
    }
  }
</nav>
<!--todo include in another release-->
<!--<nav class="nav-wrapper">-->
<!--  <p class="nav-label">{{ 'navigation.secondaryLabel' | translate }}</p>-->
<!--  @for (item of secondaryNav; track item.labelKey) {-->
<!--    <a class="nav-item" [routerLink]="item.link" (click)="onCloseMenu()" routerLinkActive="active">-->
<!--      @if (item.icon) {-->
<!--        <app-icon [name]="item.icon"></app-icon>-->
<!--      }-->
<!--      {{ item.labelKey | translate }}</a>-->
<!--  }-->
<!--</nav>-->
<nav class="nav-wrapper tertiary">
  <!--p class="nav-label">{{ "navigation.tertiaryLabel" | translate }}</p-->
  @for (item of tertiaryNav; track item.labelKey) {
    <a
      class="nav-item"
      [routerLink]="item.link"
      (click)="onCloseMenu()"
      routerLinkActive="active"
    >
      @if (item.icon) {
        <app-icon [name]="item.icon"></app-icon>
      }
      {{ item.labelKey | translate }}
    </a>
  }
</nav>
